import { useRouter } from '@capsicum/common-web';
import { useCallback } from 'react';

export const useSelectFavouriteTeam = () => {
	const { push } = useRouter();

	return useCallback(() => {
		push('/settings/select-favourite-partner');
	}, [push]);
};
